import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormsModule, ReactiveFormsModule, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ManageCardsService } from '../../payment/manage-cards/manage-cards.service';
import { MakePaymentService } from '../../payment/make-payment/make-payment.service';
import { LoggerService } from 'app/logger/logger.service';

const CARD_REGEX = /^4[0-9]{3}\-[0-9]{4}\-[0-9]{4}\-[0-9]{1}(?:[0-9]{3})?$|^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$|^3[47][0-9]{2}\-[0-9]{6}\-[0-9]{5}$|^6(?:011|5[0-9]{2})\-[0-9]{4}\-[0-9]{4}\-[0-9]{4}$/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const CVV_REGEX = /^[0-9]{3,4}$/;
const EXPIRATIONDATE_REGEX = /^(0[1-9]|1[0-2])\/[0-9]{2}$/;

@Component({
  selector: 'app-setup-autopay',
  templateUrl: './setup-autopay.component.html',
  styleUrls: ['./setup-autopay.component.css']
})
export class SetupAutopayComponent implements OnInit {
  public cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  cardFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CARD_REGEX)]);

  expirationDateFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(EXPIRATIONDATE_REGEX)]);

  ccvFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(CVV_REGEX)]);

  billingZipCodeFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(ZIPCODE_REGEX)]);

  public card_detail: Object;
  public credit_debit_number;
  public expiration_date;
  public ccv;
  public billing_zip_code;
  public add_money_valid;
  public visa_valid: boolean; // 4.
  public master_valid: boolean; // 51 through 55.
  public american_express_valid: boolean; // 37
  public discover_valid: boolean; // 6011 or 65.
  public card_ending_digit: string;
  public username: string;
  public card_max_length: number;
  public card_type: string;
  public card_name: string;
  public img: string;
  public save_card_btn: string;
  public email: string;
  public mobile: string;

  public autopay_amount: number;
  public minimum_balance: number;

  private first_recharge_min_amount: number;

  public freeTillDate: Date;
  public ip_Address: string;

  is_loader: boolean;
  private account_id: number;

  constructor(private sharedService: SharedService, private router: Router, private localStorageService: LocalStorageService,
    private activatedRoute: ActivatedRoute, private makePaymentService: MakePaymentService, private manageCardsService: ManageCardsService, private logger: LoggerService) {
    this.sharedService.setHeaderErrorMessage('set_autopay', false, 'notification error', '');
    this.sharedService.setHeaderTitle('set_autopay');
    // this.minimum_balance = 10;
    // this.autopay_amount = 20;
    // this.first_recharge_min_amount = 20;

    this.sharedService.getIpAddress()
    .then(res => {
        if (res.ip  !== undefined) {
            this.ip_Address = res.ip
        }
    });

    this.is_loader = true;
    this.sharedService.setLoader('set_autopay', true);

    this.sharedService.getConfigConst()
      .then(res => {
        if (res.status == 'success') {
          this.first_recharge_min_amount = res.results[0]['firstRechargeMinAmount'];
          this.minimum_balance = res.results[0]['autopayMinBalance'];
          this.autopay_amount = res.results[0]['autopayAmount'];
        }
      });
    if (this.localStorageService.get('token') != null) {
      this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
        .then(res => {
          this.is_loader = false;
          this.sharedService.setLoader('set_autopay', false);
          if (res.status == 'success' && res.isTerminated == false) {
            const person = res.results[0]['personal'][0];
            this.account_id = person.id;
            this.username = person['username'];
            this.email = person['email'];
            this.mobile = person['mobilePhoneNumber'];
            // this.minimum_balance = person['bal_threshold'];
            // this.autopay_amount = person['autoPayAmount'];

            const service = res.results[0]['service'][0];

            if (service){
              this.freeTillDate = new Date(service['serviceStartDate']);
              this.freeTillDate.setDate(this.freeTillDate.getDate() + 5);
            }                     

            const that = this;
            setTimeout(function () {
              that.sharedService.setHeaderUserLoggedIn('set_autopay', true, person);
            }, 10);
          } else {
            this.localStorageService.remove('token');
            this.localStorageService.set('returnUrl', '/congrats');
            this.router.navigate(['./sign-in']);
          }
        });
    } else {
      this.localStorageService.set('returnUrl', 'congrats');
      this.router.navigate(['./sign-in']);
    }

    this.add_money_valid = false;
    this.visa_valid = false;
    this.master_valid = false;
    this.american_express_valid = false;
    this.discover_valid = false;
    this.card_type = 'Credit Card';
    this.card_name = '';
    this.save_card_btn = 'Get Started';
  }

  addMoneyValidate(credit_card: any) {
    if (this.expiration_date !== undefined && this.expiration_date !== '') {
      // tslint:disable-next-line:prefer-const
      let parts = this.expiration_date.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/),
        mon,
        sep,
        year;
      if (!parts) {
        return '';
      }
      mon = parts[1] || '';
      sep = parts[2] || '';
      year = parts[3] || '';
      if (credit_card.keyCode !== 8) {
        if (year.length > 0) {
          sep = '/';
        } else if (sep == '/') {
          mon = mon.substring(0, 1);
          sep = '';
        } else if (mon.length == 2 || sep.length > 0) {
          sep = '/';
        } else if (mon.length == 1 && (mon !== '0' && mon !== '1')) {
          mon = `0${mon}`;
          sep = '/';
        }
        this.expiration_date = `${mon}${sep}${year}`;
      } else {
        if (this.expiration_date.length == 2) {
          this.expiration_date = this.expiration_date[0];
        }
      }
      if (this.expiration_date.length == 6) {
        let temp = '';
        for (let i = 0; i < 5; i++) {
          temp += this.expiration_date[i]
        }
        this.expiration_date = temp;
      }
    }
    if (this.credit_debit_number !== undefined) {
      if (this.credit_debit_number.match(/^4/)) {
        this.visa_valid = true;
        this.card_name = 'Visa';
        this.american_express_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/visa.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.credit_debit_number.match(/^(5[1-5]|2[2-7])/)) {
        this.master_valid = true;
        this.card_name = 'MasterCard';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
        this.img = 'assets/images/masterCard.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.credit_debit_number.match(/^3[47]/)) {
        this.american_express_valid = true;
        this.card_name = 'American Express';
        this.visa_valid = false;
        this.discover_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/americanExpress.png';
        this.card_max_length = 17;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/];
        }
      } else if (this.credit_debit_number.match(/^6([045]|22)/)) {
        this.discover_valid = true;
        this.card_name = 'Discover';
        this.visa_valid = false;
        this.american_express_valid = false;
        this.master_valid = false;
        this.img = 'assets/images/discover.png';
        this.card_max_length = 19;
        if (credit_card.keyCode !== 8) {
          this.cardMask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
        }
      } else {
        this.visa_valid = false;
        this.card_name = '';
        this.master_valid = false;
        this.american_express_valid = false;
        this.discover_valid = false;
      }
    }
    if (this.credit_debit_number !== '' && this.expiration_date !== '' && this.ccv !== '' &&
      this.billing_zip_code !== '' && this.credit_debit_number !== undefined &&
      this.expiration_date !== undefined && this.ccv !== undefined && this.ccv.match(CVV_REGEX) && this.billing_zip_code !== undefined
      && this.credit_debit_number.length > 12 && this.ccv.length > 2 &&
      this.billing_zip_code.match(ZIPCODE_REGEX) && this.credit_debit_number.match(CARD_REGEX) &&
      this.expiration_date.match(EXPIRATIONDATE_REGEX)) {
      this.add_money_valid = true;
      if (credit_card.keyCode == 13) {
        document.getElementById('next_pay').click();
      }
    } else {
      this.add_money_valid = false;
    }
  }

  saveCard() {
    this.sharedService.setHeaderErrorMessage('set_autopay', false, 'notification error', '');
    if (this.card_name !== '') {
      this.card_ending_digit = this.credit_debit_number.substring(this.credit_debit_number.length - 4, this.credit_debit_number);
      this.save_card_btn = 'Getting Started..';
      this.add_money_valid = false;

      this.card_detail = {
        'CardNumber': this.unmaskData(this.credit_debit_number),
        'ExpireMonth': this.expiration_date,
        'CCV': this.ccv,
        'CardZipCode': this.billing_zip_code,
        'PaymentAmount': this.first_recharge_min_amount.toString(),
        'token': this.localStorageService.get('token'),
        'mobilePhoneNumber': this.mobile,
        'email': this.email,
        'save_card': true,
        'cardName': this.card_name,
        'cardType': this.card_type,
        'IPAddress' : this.ip_Address,
      }
      let methodName = this.constructor.name + '.paymentPay';
      this.makePaymentService.paymentPay(this.card_detail)
        .then(res => {
          this.card_detail['CardNumber'] = "[masked]-" + this.card_detail['CardNumber'].substr(this.card_detail['CardNumber'].length - 4);
          this.card_detail['ExpireMonth'] = "[masked]";
          this.card_detail['CCV'] = "[masked]";
          this.card_detail['CardZipCode'] = "[masked]";
          this.card_detail['token'] = "[masked]";
          let logObj = {
            method: methodName,
            request: this.card_detail,
            response: res
          };
          this.logger.logInfo(JSON.stringify(logObj));
          if (res.result.status == 'success') {
            this.setAutoPayment();
          } else {
            window.scrollTo(0, 0);
            this.sharedService.setHeaderErrorMessage('set_autopay', true, 'notification error', res.result.message);
          }
        });
    } else {
      window.scrollTo(0, 0);
      this.sharedService.setHeaderErrorMessage('set_autopay', true, 'notification error', 'Invalid Card');
    }
  }

  unmaskData(data: string) {
    if (data != null && data.trim()!="") {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return "";
    }
  }

  setAutoPayment() {
    const data = {
      'autoPayAmount': this.autopay_amount,
      'bal_threshold': this.minimum_balance,
      'token': this.localStorageService.get('token'),
      'active': true
    }

    this.manageCardsService.setAutoPayThreshold(data).then(res => {
      this.add_money_valid = true;
      this.save_card_btn = 'Get Started';

      if (res.status == 'success') {
        var dataLayerEvent = 'enroll - initial payment made';
        (window as any).dataLayer.push({ 'event': dataLayerEvent, 'auto-pay': 1, 'accountID': this.account_id.toString() });
        this.sharedService.setHeaderSuccessMessage('autopay_setting', true, res.message);
        const this_obj = this;
        setTimeout(
          function () {
            this_obj.sharedService.setHeaderSuccessMessage('autopay_setting', false, '');
            this_obj.router.navigate(['./dashboard']);
          }, 3000);
      } else {
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('autopay_setting', true, 'notification error', res.message);
      }
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/setup-autopay/setup-autopay.component.ts